import { render, staticRenderFns } from "./Fragen.vue?vue&type=template&id=3de89a52&scoped=true&lang=html"
import script from "./Fragen.vue?vue&type=script&lang=js"
export * from "./Fragen.vue?vue&type=script&lang=js"
import style0 from "./Fragen.vue?vue&type=style&index=0&id=3de89a52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de89a52",
  null
  
)

export default component.exports